// extracted by mini-css-extract-plugin
module.exports = {"container":"section_container__1hJOo"};